'use client';

import { useContainerSize } from '@ui/shared/ContainerSizeProvider/ContainerSizeProvider';

const MIN_VIEWPORT_WIDTH_FOR_EQUIPMENT_COMPACT_COLUMN = 568;
const MIN_VIEWPORT_WIDTH_FOR_SEPARATED_BROKER_AND_PICKUP_COLUMNS = 664;
const MIN_VIEWPORT_WIDTH_FOR_SEPARATED_EQUIPMENT_COLUMNS = 808;
const MIN_VIEWPORT_WIDTH_FOR_DELIVERY_COLUMN = 904;
const MIN_VIEWPORT_WIDTH_FOR_DISTANCE_COLUMN = 996;
const MIN_VIEWPORT_WIDTH_FOR_CALL_TO_ACTION_COLUMN = 1146;
const MIN_VIEWPORT_WIDTH_FOR_SEPARATED_STOP_COLUMNS = 1322;

interface Props {
  ageColumn: React.ReactNode;
  brokerColumn: React.ReactNode;
  brokerAndPickupColumn: React.ReactNode;
  distanceColumn: React.ReactNode;
  pickupAppointmentColumn: React.ReactNode;
  pickupAddressColumn: React.ReactNode;
  tripArrowAndExtraStopsColumn: React.ReactNode;
  deliveryAppointmentNextToAddressColumn: React.ReactNode;
  deliveryAppointmentColumn: React.ReactNode;
  deliveryAddressColumn: React.ReactNode;
  stopsColumn: React.ReactNode;
  equipmentCompactColumn: React.ReactNode;
  trailerTypeColumn: React.ReactNode;
  dimensionsColumn: React.ReactNode;
  callToActionColumn: React.ReactNode;
  availabilityColumn: React.ReactNode;
}

export default function PublicLoadTableResponsiveRowContent({
  ageColumn,
  brokerColumn,
  brokerAndPickupColumn,
  distanceColumn,
  pickupAppointmentColumn,
  pickupAddressColumn,
  deliveryAppointmentColumn,
  deliveryAddressColumn,
  deliveryAppointmentNextToAddressColumn,
  tripArrowAndExtraStopsColumn,
  stopsColumn,
  trailerTypeColumn,
  dimensionsColumn,
  equipmentCompactColumn,
  callToActionColumn,
  availabilityColumn,
}: Props) {
  const { width: containerWidth } = useContainerSize();

  return (
    <>
      {ageColumn}
      {containerWidth >=
      MIN_VIEWPORT_WIDTH_FOR_SEPARATED_BROKER_AND_PICKUP_COLUMNS
        ? brokerColumn
        : brokerAndPickupColumn}
      {containerWidth >= MIN_VIEWPORT_WIDTH_FOR_DISTANCE_COLUMN &&
        distanceColumn}
      {containerWidth >= MIN_VIEWPORT_WIDTH_FOR_SEPARATED_STOP_COLUMNS ? (
        <>
          {pickupAppointmentColumn}
          {pickupAddressColumn}
          {tripArrowAndExtraStopsColumn}
          {deliveryAddressColumn}
          {deliveryAppointmentNextToAddressColumn}
        </>
      ) : (
        <>
          {containerWidth >=
            MIN_VIEWPORT_WIDTH_FOR_SEPARATED_BROKER_AND_PICKUP_COLUMNS &&
            pickupAppointmentColumn}
          {stopsColumn}
          {containerWidth >= MIN_VIEWPORT_WIDTH_FOR_DELIVERY_COLUMN &&
            deliveryAppointmentColumn}
        </>
      )}
      {containerWidth >= MIN_VIEWPORT_WIDTH_FOR_SEPARATED_EQUIPMENT_COLUMNS ? (
        <>
          {trailerTypeColumn}
          {dimensionsColumn}
        </>
      ) : (
        containerWidth >= MIN_VIEWPORT_WIDTH_FOR_EQUIPMENT_COMPACT_COLUMN &&
        equipmentCompactColumn
      )}
      {containerWidth >= MIN_VIEWPORT_WIDTH_FOR_CALL_TO_ACTION_COLUMN &&
        callToActionColumn}
      {availabilityColumn}
    </>
  );
}
